(function ($) {

    function updateFilterLanguage(venue, type) {

        var result = '';

        $.ajax({
            url: ppirJS.ajaxURL,
            data: {
                action: 'pici_venue_lang_object_ids',
                venue: venue,
                type: type
            },
            dataType: 'text',
            async: false,
            method: 'POST',
            success: function (data) {
                result = data;
            },
            error: function (e) {
                console.log(e);
            }
        });

        return result;
    }

    function updateFilterRegion(_target) {

        var _region = _target.attr('data-slug');

        // Update Region
        $('.region-filter__item').removeClass('active');
        $('.region-filter__item[data-slug=' + _region + ']').addClass('active');

        // Update Venue Region
        $('.venue-filter__region').removeClass('active');
        var _filter = $('.venue-filter__region[data-slug=' + _region + ']').addClass('active');

        // Update Venue Filter
        $('.venue-filter__venue').removeClass('active');
        var _venue = _filter.find('.venue-filter__venue').eq(0).addClass('active');

        // Update Drop Down
        $('.venue-drop-down__item').removeClass('active');
        var _dropDown = $('.venue-drop-down__item[data-id=' + _venue.attr('data-id') + ']').addClass('active');
        $('.current-venue').html(_dropDown.html());

        // Update Details
        $('.venue-details__item').removeClass('active');
        $('.venue-details__item[data-id=' + _venue.attr('data-id') + ']').addClass('active');

        updateLocalStorageAndWPSessionVenue(_venue.attr('data-id'));
    }

    function updateFilterVenue(_target) {

        var _targetID = _target.attr('data-id');

        // Update Venue Filter
        $('.venue-filter__venue').removeClass('active');
        var _venue = $('.venue-filter__venue[data-id=' + _targetID + ']').addClass('active');

        // Update Drop Down
        $('.venue-drop-down__item').removeClass('active');
        $('.venue-drop-down__item[data-id=' + _targetID + ']').addClass('active');
        $('.current-venue').html(_target.html());

        // Update Details
        $('.venue-details__item').removeClass('active');
        $('.venue-details__item[data-id=' + _targetID + ']').addClass('active');

        // Update Venue Region
        $('.venue-filter__region').removeClass('active');
        var _region = _venue.parents('.venue-filter__region').addClass('active');

        // Update Region
        $('.region-filter__item').removeClass('active');
        $('.region-filter__item[data-slug=' + _region.attr('data-slug') + ']').addClass('active');

        updateLocalStorageAndWPSessionVenue(_targetID);
    }

    function updateLocalStorageAndWPSessionVenue(id) {

        // Update Local Storage
        localStorage.setItem('venueID', id);

        // Update WP Session
        $.ajax({
            url: ppirJS.ajaxURL,
            data: {
                action: 'pici_venue_save_session',
                venue: id
            },
            dataType: 'text',
            async: false,
            method: 'POST',
            success: function (data) {
                // console.log(data);
            },
            error: function (e) {
                console.log(e);
            }
        });
    }

    function updatePageVenue() {

        if (
            $('body').hasClass('page-template-page-menu-archive')
            ||
            $('body').hasClass('page-template-page-venue-gallery')
        ) {
            location.reload();
        }
        else if (
            $('body').hasClass('page-template-page-menu-full-width')
            ||
            $('body').hasClass('page-template-page-menu-2-col')
        ) {

            var venue = $('.venue-drop-down__item.active').attr('data-id');

            $.ajax({
                url: ppirJS.ajaxURL,
                data: {
                    action: 'pici_venue_menu',
                    pageID: $('#primary').attr('pageID'),
                    venue: venue
                },
                dataType: 'text',
                async: false,
                method: 'POST',
                success: function (data) {

                    if (data) {
                        window.location = data;
                    }
                },
                error: function (e) {
                    console.log(e);
                }
            });
        }
    }

    function updateFilterPosition(_width) {

        if (
            $('.page-template-page-menu-2-col').length
            ||
            $('.page-template-page-menu-full-width').length
        ) {
            if (_width > 992) {

                $('.menu-local-nav .local-nav').prepend($('.venue-filter-wrapper'));
            }
            else {

                $('.venue-filter-wrapper').insertBefore($('.menu-local-nav .local-nav'));
            }
        }
        else if ($('.page-template-page-venue-gallery').length) {

            if (_width > 992) {

                $('.venue-filter-wrapper').appendTo($('#attachment-tag-filter ul'));
            }
            else {

                $('.venue-filter-wrapper').insertBefore($('#attachment-tag-filter'));
            }
        }
    }

    $(document).ready(function () {

        if ($('.pici-venue-active').length) {

            var body = $('body');
            var _width = window.innerWidth;

            Object.defineProperty(localStorage, "getItem", {
                value: function (sKey) { return sKey ? this[sKey] : null; },
                writable: false,
                configurable: false,
                enumerable: false
            });

            var storage = localStorage.getItem('venueID');

            if(storage === null || storage === undefined || storage === '' || !localStorage['venueID'] || localStorage.getItem('venueID') === null) {

                var item = '';

                $('.region-filter').each(function () {
                    $(this).find('.region-filter__item').eq(0).addClass('active');
                });

                $('.venue-filter').each(function () {
                    var region = $(this).find('.venue-filter__region').eq(0).addClass('active');
                    region.find('.venue-filter__venue').eq(0).addClass('active');
                });

                $('.venue-drop-down-filter').each(function () {
                    var _this = $(this);
                    item = _this.find('.venue-drop-down__item').eq(0).addClass('active');
                    _this.find('.current-venue').html(item.html());
                });

                $('.venue-details').each(function () {
                    $(this).find('.venue-details__item').eq(0).addClass('active');
                });

                var translatedVenueID = updateFilterLanguage(item.attr('data-id'), 'pici_venue');
                updateLocalStorageAndWPSessionVenue(translatedVenueID);
                console.log('b - 2 : ' +  item.attr('data-id'));
                console.log('b - 2 : ' +  translatedVenueID);
            }
            else {

                var venueID = localStorage.getItem('venueID');
                var translatedVenueID = updateFilterLanguage(venueID, 'pici_venue');
                updateFilterVenue($('.venue-filter__venue[data-id=' + translatedVenueID + ']'));
                console.log('a - 1 : ' +  venueID);
                console.log('a - 1 : ' +  translatedVenueID);
            }

            // Region filter item click
            body.on('click', '.region-filter__item', function () {
                var _this = $(this);
                if (_this.hasClass('active')) {
                    return;
                }
                updateFilterRegion(_this);
            });

            // Venue filter item click
            body.on('click', '.venue-filter__venue', function () {
                var _this = $(this);
                if (_this.hasClass('active')) {
                    return;
                }
                updateFilterVenue(_this);
            });

            // Current venue click on drop down filter
            body.on('click', '.current-venue', function () {
                $(this).next('.venue-drop-down').stop(true, true).slideToggle(300);
            });

            // Drop down item click
            body.on('click', '.venue-drop-down__item', function () {
                var _this = $(this);
                if (_this.hasClass('active')) {
                    $('.venue-drop-down').stop(true, true).slideUp(300);
                    return;
                }
                updateFilterVenue(_this);
                $('.venue-drop-down').stop(true, true).slideUp(300);
                updatePageVenue();
            });

            updateFilterPosition(_width);

            $(window).resize(function () {
                _width = window.innerWidth;
                updateFilterPosition(_width);
            });
        }

    });

})(jQuery);